const hasPermission = {
  install (Vue) {
    Vue.directive('has', {
      bind: (el, binding, vnode)=>{
        filterGlobalPermission(el, binding, vnode);
      }
    });
  }
};
/**
 * 全局权限控制
 */
export const filterGlobalPermission = (el, binding) => {
  let {value} = binding;
  let permissionList = JSON.parse(localStorage.getItem('permissions') || "[]");
  // console.log(permissionList)
  // let authList = JSON.parse(localStorage.getItem('LOGIN_USER_BUTTON_AUTH') || "[]");
  // for (let auth of authList) {
  //   permissionList.push(auth);
  // }
  let hasBtn = permissionList.includes(value);
  //没有权限则删除父元素，或者隐藏当前元素
  if (!hasBtn) {
    if (!el.parentNode) {
      el.style.display = 'none'
    } else {
      el.parentNode.removeChild(el)
    }
  }
}
export default hasPermission;
